import BaseNavbar, { type NavItemProps } from '@/shared/components/BaseNavbar';
import ThreeDotsMenu, { standardItems } from '@/shared/components/flip-ui-kit/ThreeDotsMenu';
import { ConnectButton } from '@/shared/components/RainbowKit';
import CpuIcon from '@/shared/icons/flip-ui-kit/large/Cpu';
import PolkaConnectInfo from './PolkaConnectInfo';
import { useStateChainAccount } from '../../hooks/useStateChainAccount';

const items: NavItemProps[] = [
  {
    type: 'link',
    href: '/delegate',
    children: 'Delegate',
  },
  {
    type: 'link',
    href: '/operators',
    children: 'Operators',
  },
  {
    type: 'link',
    href: '/auction',
    children: 'Auction',
  },
  {
    type: 'link',
    href: process.env.NEXT_PUBLIC_EXPLORER_URL as string,
    children: 'Block Explorer',
    target: '_blank',
  },
];

const Navbar = () => {
  const { account } = useStateChainAccount();

  return (
    <BaseNavbar
      className="z-50 border-b border-cf-gray-3"
      logoHref="/auction"
      navItems={items}
      hideNetworkBadgeOnMdDevices
      actions={
        <>
          <div>
            <ConnectButton disabled={['sol', 'tron']} />
          </div>
          <div>
            <PolkaConnectInfo boundRedeemAddress={account?.bound_redeem_address} />
          </div>
          <div className="hidden md:block">
            <ThreeDotsMenu
              items={[
                {
                  label: 'Delegation Calculator (Beta)',
                  Icon: CpuIcon,
                  href: '/calculator',
                },
                ...standardItems,
              ]}
            />
          </div>
        </>
      }
    />
  );
};

export default Navbar;
